





















import { Component, Vue, Watch } from 'vue-property-decorator';

@Component
export default class GlobalSnackbar extends Vue {
  public show = false;
  public text = '';
  public state = '';

  get snackbar() {
    return this.$store.getters.snackbar;
  }

  @Watch('snackbar')
  public watchSnackbar(val: { state: string, text: string }) {
    if (val !== null && val.text !== '') {
      this.text = val.text;
      this.state = val.state;
      this.show = true;
      // this.$store.commit('resetSnackbar');
    }
  }

  public onClickClose() {
    this.show = false;
  }
}
